import { createAsyncThunk } from "@reduxjs/toolkit";
import { createMemoriesUploadUrl, uploadVideoS3 } from "services/shortService";

interface UploadParams {
  file: File;
  folderName: string;
  fileName: string;
  url?: string;
  mimetype?: string;
}

// ✅ Step 1: Get Pre-signed URL
export const createUploadURL = createAsyncThunk(
  "images/createMemoriesUploadURL",
  async ({ folderName, fileName }: { folderName: string; fileName: string }, thunkAPI) => {
    try {
      const response = await createMemoriesUploadUrl(folderName, fileName);
      return response; // Should return the upload URL
    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to create memories upload URL");
    }
  }
);

// ✅ Step 2: Upload Image to S3
export const uploadVideo = createAsyncThunk(
  "video/upload",
  async ({ file, url,mimetype }: Partial<UploadParams>, thunkAPI) => {
    try {
      const response = await uploadVideoS3(file as File, url as string,mimetype as string);
      if(response.status===200){
        return {
          status:200,
          message:"Video uploaded successfully"
        }
      }else{
        return {
          status:500,
          message:"Failed to upload video"
        }
      }
    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to upload video");
    }
  }
);



// ✅ Step 3: Upload Shorts Video 
export const uploadShorts = createAsyncThunk(
  "shorts/uploadShorts",
  async ({ file, folderName, fileName, mimetype }: UploadParams, thunkAPI) => {
    try {
      // 1️⃣ Get Pre-signed URL
      const uploadUrlResponse = await thunkAPI.dispatch(createUploadURL({ folderName, fileName })).unwrap();

      if (uploadUrlResponse===null || !uploadUrlResponse.uploadURL) {
        throw new Error("Failed to get pre-signed URL");
      }
      // 2️⃣ Upload Video to S3
      const url = uploadUrlResponse.uploadURL as string;
      await thunkAPI.dispatch(uploadVideo({ file, url, mimetype })).unwrap();
      
      return {
        fileName,
        mimetype: mimetype,
        preview: `https://d3thbee5ims1p2.cloudfront.net/${folderName}/${fileName}`,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to upload shorts");
    }
  }
);